;(function initCustomerPrivacyConsent() {
  const logPrefix = '[customer-privacy]'
  const log = (...args) => { try { console.log(logPrefix, ...args) } catch (_) {} }
  const warn = (...args) => { try { console.warn(logPrefix, ...args) } catch (_) {} }
  const error = (...args) => { try { console.error(logPrefix, ...args) } catch (_) {} }

  log('Customer Privacy API Initializer start')
  let onetrustListenerAttached = false;

  function readConsentFlags() {
    const groups = window.OnetrustActiveGroups || '';
    log('Reading consent flags from OnetrustActiveGroups:', groups)
    const preferencesAllowed = groups.includes('C0001');
    const marketingAllowed = groups.includes('C0003');
    const analyticsAllowed = groups.includes('C0002') || groups.includes('C0005');
    const saleOfDataAllowed = groups.includes('C0004');

    const flags = {
      analytics: analyticsAllowed,
      marketing: marketingAllowed,
      preferences: preferencesAllowed,
      sale_of_data: saleOfDataAllowed,
    };
    log('Computed consent flags:', flags)
    return flags
  }

  function applyShopifyConsent() {
    try {
      const flags = readConsentFlags();
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        log('Applying consent to Shopify.customerPrivacy.setTrackingConsent', flags)
        window.Shopify.customerPrivacy.setTrackingConsent(flags, function noop() { log('Shopify setTrackingConsent callback') });
      } else {
        warn('Shopify.customerPrivacy.setTrackingConsent not available yet')
      }
    } catch (e) {
      error('Failed to apply Shopify consent', e)
    }
  }

  function loadConsentTrackingAPI(callback) {
    const proceed = () => {
      log('Consent-tracking API ready')
      if (typeof callback === 'function') callback();
    };

    if (!window.Shopify || !window.Shopify.loadFeatures) {
      log('Shopify.loadFeatures not yet available, starting poll')
      const iv = setInterval(() => {
        if (window.Shopify && window.Shopify.loadFeatures) {
          clearInterval(iv);
          log('Shopify.loadFeatures available, loading consent-tracking-api')
          window.Shopify.loadFeatures([
            { name: 'consent-tracking-api', version: '0.1' },
          ], function(err) {
            if (err) { warn('Error from Shopify.loadFeatures callback (polled init):', err) }
            proceed();
          });
        }
      }, 100);
      return;
    }

    try {
      log('Calling Shopify.loadFeatures for consent-tracking-api')
      window.Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' },
      ], function(err) {
        if (err) { warn('Error from Shopify.loadFeatures callback:', err) }
        proceed();
      });
    } catch (e) {
      warn('Exception calling Shopify.loadFeatures, proceeding anyway', e)
      proceed();
    }
  }

  function attachOneTrustListener() {
    if (!window.OneTrust || onetrustListenerAttached) { if (!window.OneTrust) log('attachOneTrustListener: OneTrust not available'); return; }
    onetrustListenerAttached = true;
    log('Attaching OneTrust.OnConsentChanged listener')

    // Initial sync on load
    applyShopifyConsent();

    // React to subsequent changes
    window.OneTrust.OnConsentChanged(function onConsentChanged() {
      log('OneTrust.OnConsentChanged fired')
      applyShopifyConsent();
    });
  }

  function waitForOneTrustAndAttach() {
    if (window.OneTrust) {
      log('OneTrust already available, attaching listener')
      attachOneTrustListener();
      return;
    }
    // OneTrust dispatches a global event when loaded
    log('Waiting for OneTrustLoaded event')
    window.addEventListener('OneTrustLoaded', function handleOTLoaded() {
      log('OneTrustLoaded event received')
      attachOneTrustListener();
    }, { once: true });

    // Fallback: poll in case event fired before listener attached
    const iv = setInterval(() => {
      if (window.OneTrust) {
        clearInterval(iv);
        log('OneTrust detected via polling, attaching listener')
        attachOneTrustListener();
      }
    }, 200);
  }

  // Load Shopify consent-tracking API first, then wait for OneTrust and attach listeners
  loadConsentTrackingAPI(function onConsentAPIReady() {
    log('Consent API ready callback, proceeding to wait for OneTrust')
    waitForOneTrustAndAttach();
  });
})();